import { tv, type VariantProps } from "tailwind-variants";

export const headerVariant = tv(
  {
    slots: {
      base: [
        "fixed",
        "top-0",
        "left-0",
        "right-0",
        "z-18",
        "flex",
        "items-center",
        "justify-center",
        "w-full",
        "bg-white/80",
        "border-b",
        "border-neutral-dark-alpha/10",
        "backdrop-blur-lg",
        "dark:bg-black/80",
      ],
      wrapper: [
        "container-fluid",
        "flex",
        "items-center",
        "justify-between",
        "w-full",
        "h-18",
        "desktop:justify-start",
      ],
      logo: ["h-[22px] w-full max-w-32"],
      nav: [
        "flex",
        "items-center",
        "justify-between",
        "mobile:w-full",
        "mobile:bg-white",
        "mobile:dark:bg-black",
        "mobile:flex-col",
        "mobile:items-start",
        "mobile:gap-10",
        "mobile:absolute",
        "mobile:z-50",
        "mobile:left-0",
        "mobile:top-[calc(100%+160px)]",
        "mobile:pt-2",
        "mobile:pb-10",
        "mobile:px-2",
        "mobile:transition-all",
        "mobile:duration-300",
        "mobile:h-[calc(100vh_-_72px)]",
        "desktop:flex-grow",
        "desktop:ml-5",
      ],
      menu: [
        "flex",
        "flex-col",
        "items-start",
        "gap-2",
        "w-full",
        "desktop:flex-row",
        "desktop:items-center",
        "desktop:gap-0",
        "desktop:w-auto",
      ],
      menuItemWrapper: ["mobile:w-full", "mobile:px-2"],
      menuItem: [
        "relative",
        "flex",
        "items-center",
        "gap-2",
        "py-3",
        "px-4",
        "border-0",
        "font-demibold",
        "text-5",
        "text-neutral-12",
        "overflow-visible",
        "after:content-['']",
        "after:block",
        "after:z-10",
        "after:h-0.25",
        "after:w-full",
        "after:bg-transparent",
        "after:absolute",
        "after:bottom-0",
        "after:left-0",
        "after:bottom-[-15px]",
        "after:transition-all",
        "after:duration-300",
        "after:ease-in-out",
        "after:scale-x-0",
        "after:origin-bottom-right",
        "hover:text-black aria-[current=page]:text-black",
        "desktop:hover:bg-transparent desktop:aria-[current=page]:bg-transparent",
        "desktop:hover:border-transparent desktop:aria-[current=page]:border-transparent",
        "desktop:hover:after:scale-x-100 desktop:aria-[current=page]:after:scale-x-100",
        "desktop:hover:after:origin-bottom-left desktop:aria-[current=page]:after:origin-bottom-left",
        "desktop:hover:after:bg-black desktop:aria-[current=page]:after:bg-black",
        "desktop:hover:dark:after:bg-white desktop:aria-[current=page]:dark:after:bg-white",
        "hover:dark:text-white aria-[current=page]:dark:text-white",
        "mobile:hover:bg-surface-neutral-soft",
        "mobile:hover:rounded-md",
        "desktop:px-5",
        "desktop:text-3",
        "desktop:font-medium",
        "desktop:text-static-black-soft",
      ],
      menuItemIcon: ["w-4", "h-4"],
      actionsMenu: ["flex", "items-center", "gap-2"],
      iconButton: ["flex"],
      hamburgerButton: ["flex", "desktop:hidden"],
    },
    variants: {
      opened: {
        false: {
          nav: ["mobile:translate-y-full"],
        },
        true: {
          nav: ["mobile:-translate-y-[160px]"],
        },
      },
    },
    defaultVariants: {},
  },
  { twMerge: false },
);

export type HeaderVariantProps = VariantProps<typeof headerVariant>;

export type HeaderReturnVariantProps = ReturnType<typeof headerVariant>;
